import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  inputContainer: {
    display: 'flex',
    gap: '16px',
    marginTop: '1rem'
  }
}));
